module.exports = __webpack_public_path__ + "img/cabinet_connect.8ae72e25.svg";